import React from 'react';
import { ReactComponent as Plus } from 'assets/icons/beacon/Plus.svg';
import { ReactComponent as Pencil } from 'assets/icons/beacon/Pencil.svg';
import DataCard from 'components/shared/DataCard/DataCard';
import BeneficiaryDataCardBody from './BeneficiaryDataCardBody';
import BeaconNotification from 'components/shared/BeaconNotification/BeaconNotification';
import { popoverContent, replaceStringIfEducationSavings, formatStringIfEducationSavings } from 'services/BeneficiaryV2';
import { AAMBeaconIconButton, AAMBeaconPopover } from 'components/shared/Beacon';
import { ReactComponent as Icon } from 'assets/icons/beacon/Information.svg';
import "./BeneficiaryDataCardGroupSection.scss";

const EsaPopoverButton = () => (
    <>
      <AAMBeaconIconButton id="popover-esa-trigger" variant='tertiary' aria-label="esaButton">

        <Icon slot="icon" />
      </AAMBeaconIconButton>
      <AAMBeaconPopover
        opens-by="#popover-esa-trigger"
        placement='right-end'
      >
        <h2 slot="title">{popoverContent.ESA_DEFINITION.title}</h2>
        <div>{popoverContent.ESA_DEFINITION.answer}</div>
      </AAMBeaconPopover>
    </>
);

const BeneficiaryDataCardHeader = ({ displayName, isEsa }) => {
  if (!isEsa) {
    return <>{displayName}</>;
  }

  const index = displayName.indexOf('(');
  const accountName = displayName.substring(0, index);
  const ownerNames = displayName.substring(index);

  return (
    <>
      <span className="beneficiary-esa-header-with-popover">
        {accountName}
        <EsaPopoverButton className="beneficiary-esa-popover-button" />
      </span>
      <br />
      <span>{ownerNames}</span>
    </>
  );
};

const BeneficiaryDataCardGroupSection = ({
  title,
  data,
  handleHeaderCTA,
  handleAddBeneficiary,
  handleManageBeneficiary,
  setSelectedGroup,
  setAgreementsForBeneUpdate,
  setRegistrationKeyForMismatchUpdate,
  handleTODAccounts,
}) => (
  <div className="b-grid-item--8-col datacard">
    <div className="b-typography-serif--headline--500 b-color-text--title title-space">
      {title}
    </div>
    {data.map(({ isEditable, displayName, isEsa, isIndividual, isJoint, beneficiaries, pendingText, agreements, displayMismatchBanner, beneficiariesMatch, displayGroupName, registrationValue }, index) => {
      const { beneficiaryCount } = beneficiaries;
      return (
        <DataCard
          key={index}
          cardHeaderTitle={<BeneficiaryDataCardHeader displayName={displayName} isEsa={isEsa} />}
          cardMismatchBanner={
            displayMismatchBanner && isEditable && (
              <BeaconNotification
                title="Immediate action required."
                description={formatStringIfEducationSavings(`Some of your beneficiary information is inconsistent and needs to be reentered and resubmitted. Once resubmitted, the new information will apply to all identically registered ${displayGroupName}s.`, isEsa)}
                ctalabel="Reenter Beneficiaries"
                variant="error"
                dismissable
                showActionZone
                ctaAction={() => {
                  handleAddBeneficiary(beneficiaries, true, isEsa);
                  setSelectedGroup(displayName);
                  setRegistrationKeyForMismatchUpdate(registrationValue);
                }}
              />
            )}
          cardHeaderCTAText="View Investments"
          cardHeaderCTAVariant="tertiary"
          cardHeaderCTAHandler={() => {
            handleHeaderCTA();
            setAgreementsForBeneUpdate(agreements)
          }}
          cardBody={
            <BeneficiaryDataCardBody
              className={'beneficiaries-data-card-body'}
              beneficiaries={beneficiaries}
              pendingText={pendingText}
              isEsa={isEsa}
              isIndividual={isIndividual}
              isJoint={isJoint}
            />
          }
          cardFooterPrimaryCTAText={
            beneficiaryCount > 0 && beneficiariesMatch && !pendingText ? replaceStringIfEducationSavings('Manage Beneficiaries', isEsa) : ''
          }
          cardFooterPrimaryCTAHandler={() => {
            handleManageBeneficiary(beneficiaries, isEsa);
            setSelectedGroup(displayName);
            setAgreementsForBeneUpdate(agreements);
          }}
          cardFooterPrimaryCTAVariant="secondary"
          cardFooterPrimaryIconComponent={<Pencil slot={'prefix'} />}
          cardFooterSecondaryCTAText={
            (isIndividual || isJoint)
              ? "Update Account"
              : (beneficiariesMatch && !pendingText
                ? replaceStringIfEducationSavings("Add Beneficiaries", isEsa)
                : "")
          }
          cardFooterSecondaryCTAHandler={() => {
            if (isIndividual || isJoint) {
              handleTODAccounts(beneficiaries, isIndividual, isJoint);
            } else {
              handleAddBeneficiary(beneficiaries, false, isEsa);
            }
            setSelectedGroup(displayName);
            setAgreementsForBeneUpdate(agreements);
          }}
          cardFooterSecondaryCTAVariant="secondary"
          cardFooterSecondaryIconComponent={(isIndividual || isJoint) ? null : <Plus slot={'prefix'} />}
          isEditable={isEditable}
        />
      );
    })}
  </div>
);

export default BeneficiaryDataCardGroupSection;

